module.exports = __webpack_public_path__ + "static/loanerhub-setup-11037bbed4e34f676b6c9b42ab3fc5e7.jpg";